export const createDebugLogger = (prefix: string, shouldLog?: boolean) => {
  if (
    typeof window !== 'undefined' &&
    localStorage.getItem('debugModeOn') &&
    shouldLog
  ) {
    // eslint-disable-next-line no-console
    return console.info.bind(null, prefix);
  }
  return () => {};
};
